import { Box, SxProps, Theme } from '@mui/material';
import { THUMBNAIL_HEIGHT } from '../consts';
import { ThumbnailImageMetadata } from '../types';
import { getThumbnailFrameBackground, ThumbnailSpriteMode } from '../utils';

export type ThumbnailSpriteProps = {
  /** Public URL of the sprite sheet image. */
  url: string;
  /** Sprite layout metadata (columns, rows, pixel size). */
  metadata: ThumbnailImageMetadata;
  /** Zero-based frame index into the sprite sheet. */
  frameIndex: number;
  /**
   * `px` sizes a filmstrip cell from targetHeight; `fill` covers the parent box.
   */
  mode: ThumbnailSpriteMode;
  /** Used when mode is `px` (defaults to logger filmstrip height). */
  targetHeight?: number;
  sx?: SxProps<Theme>;
};

/**
 * Borderless presentational sprite surface: shows one frame of a thumbnail strip.
 * No chrome, animation, or preload — callers own those concerns.
 */
export function ThumbnailSprite({
  url,
  metadata,
  frameIndex,
  mode,
  targetHeight = THUMBNAIL_HEIGHT,
  sx,
}: ThumbnailSpriteProps) {
  const frameStyles = getThumbnailFrameBackground(
    metadata,
    frameIndex,
    mode,
    mode === 'px' ? targetHeight : undefined,
  );

  return (
    <Box
      sx={{
        backgroundImage: `url(${url})`,
        backgroundSize: frameStyles.backgroundSize,
        backgroundPosition: frameStyles.backgroundPosition,
        backgroundRepeat: frameStyles.backgroundRepeat,
        width: frameStyles.width,
        height: frameStyles.height,
        flexShrink: 0,
        ...sx,
      }}
    />
  );
}
